export default {
    key: 'ski',
    common: {
        productName: 'core.productNames.ski',
        splashMessage: 'offerFlow.splashMessage.ski',
        headingAside: 'offerFlow.headingAside.ski',
    },
    stepDate: {
        heading: 'offerFlow.pages.stepDate.heading.ski',
    },
    stepPassengers: {
        heading: 'offerFlow.pages.stepPassengers.heading.ski',
        body: 'offerFlow.pages.stepPassengers.body.ski',
    },
} satisfies OfferFlowContent;
